<template>
  <div
    class="column has-text-centered opportunity-item"
    :style="{ color: trainingIsActive ? 'black' : '#d1d1d1' }"
  >
    <b-icon
      icon="cogs"
      :style="{ color: trainingIsActive ? 'black' : '#d1d1d1' }"
    ></b-icon>
    <br />

    <span>Treinamento</span>
  </div>
</template>

<script>
export default {
  props: ["trainingIsActive"]
};
</script>

<style scoped>
div {
  font-size: 1rem;
}
</style>
